import { WarningTwoIcon } from "@chakra-ui/icons";
import {
    Box,
    Button,
    CloseButton,
    HStack,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalOverlay,
    Spacer,
    Text,
    VStack
} from "@chakra-ui/react";

const PaymentSubscriptionModal = (props) => {
  return (
    <Modal 
        isOpen={props.isOpen} 
        onClose={props.onClose} 
        isCentered 
        closeOnOverlayClick={false}
        closeOnEsc={false}
        >
        <ModalOverlay />
        <ModalContent>
          <Box bg="red.500" color="white" p={4} borderTopRadius="md">
            <HStack>
              <WarningTwoIcon size="lg" />
              <Text  fontSize = "lg" fontWeight="500">Subscription Payment Overdue</Text>
              <Spacer />
              {props.userLocked ? null : <CloseButton onClick={props.handleClose} />}
            </HStack>
          </Box>
          <ModalBody pt={6}>
            <VStack spacing={4} align="stretch">
              <Text fontSize="1rem" color="grey" fontWeight="400">
                Your subscription payment is overdue. To continue using our services without interruption, please call 1-866-658-2220.
              </Text>
              <Text fontSize="1rem" color="blackAlpha.800" fontWeight="500">
                Your account access will be limited until payment is received.
              </Text>
            </VStack>
          </ModalBody>
          <ModalFooter pb={4}>
            {props.userLocked ? null :
             <Button 
              variant="outline" 
              onClick={props.handleClose}
              size="md"
              colorScheme="grey"
              borderColor="grey"  
              textColor="blackAlpha.700"                                                  
            >
              Remind Me Later                                                                     
            </Button> }
          </ModalFooter>
        </ModalContent>
      </Modal>
    
  )
}

export default PaymentSubscriptionModal;